import { inView } from '../utils/inview';

const lazyLoadImages = () => {
  $('img').each(function () {
    const img = $(this);

    if (inView(img) && img.data('src') !== '') {
      img.attr('src', img.data('src'));
    }
  });
};

export default lazyLoadImages;
